export const constants = {
  zIndexes: {
    drawer: 2147483639,
    drawerComboboxList: 2147490000,
  },
} as const;
